module.exports = __webpack_public_path__ + "img/circle-regular.75c277c.svg";